import store from '../../../store/adminPermissionStore'

export function getAdminAuthorization(eventName) {
  return store.state.auth[eventName]
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/adminAuth.js